<template>
  <div class="auth-otp">
    <input
      v-for="(cell, index) in length"
      :key="index"
      :ref="'cell-' + index"
      class="auth-otp__cell"
      :class="{ 'is-filled': !!digits[index] }"
      type="tel"
      inputmode="numeric"
      autocomplete="one-time-code"
      maxlength="1"
      :disabled="disabled"
      :value="digits[index]"
      @input="handleInput(index, $event)"
      @keydown.delete="handleBackspace(index, $event)"
      @keydown.left="focusCell(index - 1)"
      @keydown.right="focusCell(index + 1)"
      @focus="selectCell(index)"
      @paste="handlePaste" />
  </div>
</template>

<script>
  const DIGITS_ONLY = /\D/g;

  export default {
    name: 'AuthOtpInput',
    props: {
      value: {
        type: String,
        default: ''
      },
      length: {
        type: Number,
        default: 6
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      digits() {
        const chars = String(this.value).split('');
        const cells = [];
        for (let index = 0; index < this.length; index += 1) {
          cells.push(chars[index] || '');
        }
        return cells;
      }
    },
    methods: {
      emitDigits(cells) {
        this.$emit('input', cells.join('').slice(0, this.length));
      },
      focusCell(index) {
        if (index < 0 || index >= this.length) return;
        const cell = this.$refs['cell-' + index];
        const element = Array.isArray(cell) ? cell[0] : cell;
        if (element) element.focus();
      },
      selectCell(index) {
        const cell = this.$refs['cell-' + index];
        const element = Array.isArray(cell) ? cell[0] : cell;
        if (element) element.select();
      },
      handleInput(index, event) {
        const typed = event.target.value.replace(DIGITS_ONLY, '');
        const cells = this.digits.slice();
        cells[index] = typed.slice(-1);
        event.target.value = cells[index];
        this.emitDigits(cells);

        if (cells[index]) {
          if (index === this.length - 1) {
            event.target.blur();
            this.$emit('complete', cells.join(''));
            return;
          }
          this.focusCell(index + 1);
        }
      },
      /* an empty cell sends focus back so the whole code can be cleared with one key */
      handleBackspace(index, event) {
        if (event.target.value) return;
        event.preventDefault();
        const cells = this.digits.slice();
        cells[index - 1] = '';
        this.emitDigits(cells);
        this.focusCell(index - 1);
      },
      handlePaste(event) {
        const clipboard = event.clipboardData || window.clipboardData;
        if (!clipboard) return;
        event.preventDefault();

        const pasted = clipboard.getData('text').replace(DIGITS_ONLY, '').slice(0, this.length);
        if (!pasted) return;

        const cells = pasted.split('');
        while (cells.length < this.length) cells.push('');
        this.emitDigits(cells);

        const nextEmpty = cells.indexOf('');
        this.$nextTick(() => {
          this.focusCell(nextEmpty === -1 ? this.length - 1 : nextEmpty);
          if (nextEmpty === -1) this.$emit('complete', cells.join(''));
        });
      }
    }
  }
</script>

<style scoped>
.auth-otp {
  display: flex;
  justify-content: center;
  gap: 8px;
}
.auth-otp__cell {
  width: 46px;
  height: 54px;
  font-size: 1.25rem;
  font-weight: 600;
  color: #1C2B36;
  text-align: center;
  background: #fff;
  border: 1px solid #E0E8EF;
  border-radius: 12px;
  outline: none;
  transition: border-color .15s ease, box-shadow .15s ease;
}
.auth-otp__cell.is-filled {
  border-color: var(--merchant-primary-color, #1AA179);
}
.auth-otp__cell:disabled {
  background: #F3F6F9;
}
.auth-otp__cell:focus {
  border-color: var(--merchant-primary-color, #1AA179);
  box-shadow: 0 0 0 3px var(--merchant-primary-color-alpha-15, rgba(26, 161, 121, 0.15));
}
@media (max-width: 359px) {
  .auth-otp__cell {
    width: 40px;
    height: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/v2/auth/AuthOtpInput.vue